<template src="./tempalte.html"></template>



<script>
export default {
  name: 'MainNav',
  data() {
    return {
      MenuActive: false,
      screenWidth: document.body.clientWidth,
      screenScroll: document.body.scrollTop,
      shopcart_amount: 0,
      message_show: null,
      message_state: false,
      nav_list: [
        {
          title: "核心理念",
          link: "#HomeCoreStory"
        },
        {
          title: "起源故事",
          link: "#HomeOriginStory"
        },
        {
          title: "神像藝術",
          link: "#HomeArtStory"
        },
        {
          title: "最新動態",
          link: "#HomeNews"
        },
        {
          title: "活動花絮",
          link: "#HomeGallery"
        },
        {
          title: "交通位置",
          link: "#HomePosition"
        }
      ]
    }
  },
  mounted() {
    const that = this

    that.screenScroll =
      document.documentElement.scrollTop + document.body.scrollTop

    window.onscroll = () => {
      return (() => {
        that.screenScroll =
          document.documentElement.scrollTop + document.body.scrollTop
      })()
    }
  },
  methods: {
    ScrollToEl(ID) {
      this.MenuActive = false

      if (this.$route.name != "Home") {
        this.$router.push("/")
        setTimeout(() => {
          let el_pos = document.querySelector(ID).offsetTop
          window.scrollTo(0, el_pos - 60)
        }, 200)
      }
      else {
        let el_pos = document.querySelector(ID).offsetTop
        window.scrollTo(0, el_pos - 60)
      }
    }
  },

  watch: {
    screenScroll(val) {
      if (!this.scrolltimer) {
        this.screenScroll = val
        this.scrolltimer = true
        let that = this
        setTimeout(function () {
          that.scrolltimer = false
        }, 400)
      }
    }
  },
  computed: {
    bg_show() {
      return this.$route.name != "Home" || this.screenScroll > 200 ? true : false
    }
  }
}
</script>
